import React, { useMemo } from 'react';
import styled from 'styled-components';
import NewWindow from 'react-new-window';
import { card } from '@ubeya/shared-web/components';
import ExportableColumns from '../ExportableColumns';

const Wrapper = styled.div`
  margin: 30px;
`;

const Table = styled.table`
  margin: 20px auto;
  width: 100%;
  ${card};
  border-spacing: 0;
  ${({ $tableStyle }) => $tableStyle}
`;

const Row = styled.tr`
  &:not(:last-child) > td,
  th {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
  }
`;

const HeaderCell = styled.th`
  text-align: left;
  padding: 18px;
  font-size: 11px;
`;

const Cell = styled.td`
  padding: 12px 18px;
  font-size: 11px;
`;

const PDFTable = ({
  name,
  header,
  footer,
  columns: defaultColumns,
  optionalColumns,
  data,
  tables: defaultTables,
  onClose,
  asksColumns = false,
  tableStyle,
  timeoutForExport = 500,
  renderColumnsMenuExtraData,
  storageName = '',
  onExportFinished
}) => {
  const tables = useMemo(() => {
    if (!defaultTables) {
      return [{ data }];
    }
    return defaultTables;
  }, [data, defaultTables]);

  return (
    <ExportableColumns
      enable={asksColumns}
      defaultColumns={defaultColumns}
      optionalColumns={optionalColumns}
      onClose={onClose}
      renderColumnsMenuExtraData={renderColumnsMenuExtraData}
      storageName={storageName}
      onExportFinished={onExportFinished}>
      {({ columns }) => (
        <NewWindow
          title={name}
          onUnload={onClose}
          features={{
            width: window.screen?.width || window.innerWidth,
            height: window.screen?.height || window.innerHeight,
            top: 0,
            left: 0
          }}
          onOpen={(window) => {
            setTimeout(() => {
              window.print();
              onExportFinished?.();
            }, timeoutForExport);
          }}>
          <Wrapper>
            {header}

            {tables.map(({ title, data: tablesData }, index) => (
              <React.Fragment key={index}>
                {title}

                <Table $tableStyle={tableStyle}>
                  <thead>
                    <Row>
                      {columns.map(({ Header, dataKey, width }) => (
                        <HeaderCell key={dataKey} style={{ width }}>
                          {Header}
                        </HeaderCell>
                      ))}
                    </Row>
                  </thead>

                  <tbody>
                    {tablesData.map((item, itemIndex) => (
                      <Row key={itemIndex}>
                        {columns.map(({ dataKey, Cell: CustomCell, formatter, columnData, width }) => (
                          <Cell key={dataKey} style={{ width }}>
                            {CustomCell ? (
                              <CustomCell rowData={item} columnData={columnData} />
                            ) : formatter ? (
                              formatter(item[dataKey], item)
                            ) : (
                              item[dataKey]
                            )}
                          </Cell>
                        ))}
                      </Row>
                    ))}
                  </tbody>
                </Table>
              </React.Fragment>
            ))}

            {footer}
          </Wrapper>
        </NewWindow>
      )}
    </ExportableColumns>
  );
};

export default PDFTable;
